package com.solevo.dist.network.firebase.api.user

import com.solevo.dist.application.models.User
import com.solevo.dist.application.models.User.Companion.currentCustomerId
import com.solevo.dist.application.models.User.Companion.legalId
import com.solevo.dist.application.models.User.Companion.userContactId
import com.solevo.dist.application.models.UserType
import com.solevo.dist.network.api.user.UserRemoteSource
import com.solevo.dist.network.firebase.api.user.models.FirebaseUser
import com.solevo.dist.network.firebase.api.user.models.toUser
import com.solevo.dist.network.implementation.firebase.FirebaseFields
import com.solevo.dist.network.implementation.firebase.FirestoreCollections
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull

class UserFirebaseRemoteSource : UserRemoteSource {

    private val firestore: FirebaseFirestore = Firebase.firestore

    override fun isUserNotNull(): Result<Boolean> {
        return runCatching { Firebase.auth.currentUser != null }
    }

    override fun getCurrentUserId(): Result<String> {
        val currentUser = Firebase.auth.currentUser
        return if (currentUser != null) Result.success(currentUser.uid) else Result.failure(
            Exception("User is not logged in")
        )
    }

    override fun currentUser(): Flow<User?> {
        val currentUserId = Firebase.auth.currentUser?.uid
        println("FB: " + Firebase.auth.currentUser?.uid)
        return if (currentUserId != null) {
            Firebase.firestore
                .collection(FirestoreCollections.USER_COLLECTION)
                .where { FirebaseFields.FIREBASE_UID equalTo currentUserId }
                .snapshots()
                .map { qs ->
                    val user = qs.documents
                        .firstOrNull()
                        ?.data<FirebaseUser>()
                        ?.toUser()

                    legalId = user?.legalEntityId.orEmpty()
                    User.userType = user?.type ?: UserType.Contact
                    userContactId = user?.contactId ?: ""
                    User.updateCustomerId(user?.customerId.orEmpty())
                    println("Current [Firebase.auth.currentUser?.uid] from call: $currentUserId")
                    println("Current [currentCustomerId.value] from call: ${currentCustomerId.value}")
                    println("Current user from call: $user")
                    user


                }
        } else {
            flowOf(null)
        }
    }

    override fun getUserByCustomerId(id: String): Flow<User?> =
        Firebase.firestore
            .collection(FirestoreCollections.USER_COLLECTION)
            .where { FirebaseFields.CUSTOMER_ID equalTo id }
            .snapshots()
            .mapNotNull { qs ->
                qs.documents.firstOrNull()
                    ?.data<FirebaseUser>()
                    ?.toUser()
            }

    override suspend fun createPin(pin: String): Result<Unit> {
        return runCatching { updateUser(FirebaseFields.PIN, pin) }
    }

    private suspend fun updateUser(field: String, value: String) {
        val uid = Firebase.auth.currentUser?.uid ?: return
        firestore.collection(FirestoreCollections.USER_COLLECTION)
            .where {
                FirebaseFields.FIREBASE_UID.equalTo(uid)
            }
            .snapshots()
            .first().documents.first().reference
            .update(mapOf(field to value))
    }
}


